"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrag = void 0;
const react_1 = require("react");
const ui_1 = require("@completeanatomy/ui");
/* @todo check for using useDragHandler instead */
function useDrag(ref, onDragStart, onDrag, onDragEnd) {
    const position = (0, react_1.useRef)({ x: 0, y: 0 });
    (0, react_1.useEffect)(() => {
        const events = (0, ui_1.getPointersEvents)();
        const onMove = (e) => {
            e.stopPropagation();
            onDrag((0, ui_1.getDelta)((0, ui_1.getPosition)(e), position.current));
        };
        const onUp = (e) => {
            e.stopPropagation();
            onDragEnd((0, ui_1.getDelta)((0, ui_1.getPosition)(e), position.current));
            document.removeEventListener(events.move, onMove);
            document.removeEventListener(events.up, onUp);
        };
        const onDown = (e) => {
            e.stopPropagation();
            position.current = (0, ui_1.getPosition)(e);
            onDragStart();
            document.addEventListener(events.move, onMove);
            document.addEventListener(events.up, onUp);
        };
        const element = ref.current;
        element === null || element === void 0 ? void 0 : element.addEventListener(events.down, onDown);
        return () => {
            element === null || element === void 0 ? void 0 : element.removeEventListener(events.down, onDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, onDrag, onDragStart, onDragEnd]);
}
exports.useDrag = useDrag;
